export enum CronoTaskTodoWarning {
  EmailMissing = 'EmailMissing',
  LinkedinMissing = 'LinkedinMissing',
  PhoneMissing = 'PhoneMissing',
  TemplateVariableCanNotBeReplaced = 'TemplateVariableCanNotBeReplaced',
  PreviousTaskPending = 'PreviousTaskPending',
}
